<template>
  <div class="block wysiwyg-block py-24 sm:py-48" :class="{'w-full': inGrid}">
    <div class="container xxl:px-24">
      <div class="mx-auto w-full" :class="`md:w-${component.wysiwygSize}`">
        <div class="wysiwyg" v-html="component.content" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentBlock from '~/models/component-block';

import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    component: {
      type: ComponentBlock,
      required: true,
    },
    inGrid: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    const table = document.getElementsByTagName('table');

    for (let i = 0; i < table.length; i++) {
      table[i].classList.add('table');
    }
    this.wrapTable('<div class=\'table-container\'>', '.table', '</div>');
  },
  methods: {
    wrapTable(top: string, selector: string, bottom: string) {
      const matches = document.querySelectorAll(selector);
      for (let i = 0; i < matches.length; i++) {
        const modified = top + matches[i].outerHTML + bottom;
        matches[i].outerHTML = modified;
      }
    },
  },
});
</script>
<style scoped>
.wysiwyg {
  @apply mb-0;
}
</style>
